// extracted by mini-css-extract-plugin
export var alertIcon = "_r4-0";